import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader

import Vue from 'vue'
import Vuetify from 'vuetify'
// import Vuetify from 'vuetify/lib'

import 'vuetify/dist/vuetify.min.css'

// Translation provided by Vuetify (javascript)
import zhHans from 'vuetify/lib/locale/zh-Hans'

Vue.use(Vuetify)


export default new Vuetify({
  lang: {
    locales: {
      zhHans
    },
    current: 'zhHans',
  },
  icons: {
    iconfont: 'mdi', // 默认值 - 仅用于展示目的
  },
})



// WEBPACK FOOTER //
// ./src/plugins/vuetify.js